import React from 'react'
import { Accordion } from '@mobi/component-library/Base/Accordion'
import { type IconName, Icon } from '@mobi/component-library/Assets/Icon/Icon'
import { colors } from '@mobi/component-library/Foundations'

export const ExpandableToolboxSection: React.FC<
  {
    heading: string
    shouldUseTheme?: boolean
    icon?: IconName
  } & React.PropsWithChildren
> = ({ heading, children, shouldUseTheme = false, icon }) => {
  return (
    <Accordion
      contentLeft={icon ? <Icon name={icon} size='2rem' color={colors.neutral[600]} /> : null}
      theme={shouldUseTheme ? 'secondary' : null}
      title={heading}
    >
      <div style={{ paddingBottom: '1rem' }}>{children}</div>
    </Accordion>
  )
}
